export default __webpack_public_path__ + "static/media/pardon.68d67161.gif";